/** Verde oficial WhatsApp + icono blanco (historial unificado enviado/recibido). */
export const WA_VERDE_OFICIAL = '#25D366';
export const WA_VERDE_SOMBRA = '0 2px 6px rgba(37, 211, 102, 0.35)';

export function IconoWhatsAppHistorial({ size = 13 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.126 1.533 5.859L.054 23.447a.75.75 0 00.918.964l5.878-1.523A11.953 11.953 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.907 0-3.701-.524-5.232-1.435l-.374-.223-3.892 1.008 1.028-3.758-.244-.386A9.96 9.96 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
    </svg>
  );
}

export function tileWhatsAppHistorial(iconSize = 13) {
  return {
    accent: WA_VERDE_OFICIAL,
    bg: WA_VERDE_OFICIAL,
    shadow: WA_VERDE_SOMBRA,
    icon: <IconoWhatsAppHistorial size={iconSize} />,
  };
}

/** Formato { bg, sh, ic } usado en FichaCliente historial. */
export function tileWhatsAppHistorialFicha(iconSize = 13) {
  const t = tileWhatsAppHistorial(iconSize);
  return { bg: t.bg, sh: t.shadow, ic: t.icon };
}
